import { AmountMap } from "./types";

export const MAX_RECEIPT_FILE = 1;

export const FILE_UPLOAD_SIZE_LIMIT = 10 * 1024 * 1024; // 10MB;

export const PAYMENT_PROCESS_PERIOD = 3000;
export const MAX_RETRY_QUERY_PAYMENT_COUNT = 3;

export const STRIPE_MINIMUM_AMOUNT_MAP: AmountMap = {
  HKD: 4,
};
